export default "__VITE_ASSET__2eb9bb6b__"